import { HeyLightOrdersListScreen } from "./HeyLightOrdersListScreen.tsx";

export const AdminHeyLightAllOrdersScreenPath = "/admin/heylight/all-orders";

export function AdminHeyLightAllOrdersScreen() {
  return <HeyLightOrdersListScreen />;
}
